/* yct-resolve.js -- authoritative variant resolution for high-variant products.

   Shopify's storefront serves at most 250 variants per product, so the theme's
   embedded variant JSON is truncated past that and its client-side matching
   silently picks a WRONG variant. Verified on this store before this file
   existed: choosing Navy / YL / Long Sleeve put Navy / S / Short Sleeve in the
   cart at the wrong price.

   Fix: stop matching locally. Send the chosen option-value ids to Shopify via
   ?option_values=<id>,<id>,<id> and use whatever variant it returns. The ids
   come from the #yct-option-map blob that snippets/global-script-2.liquid
   prints, and the response is fetched through the Section Rendering API so
   only the product section comes back (~390KB, ~345ms) rather than the whole
   1.7MB page.

   If the map or the section id is missing this does nothing at all, leaving
   the theme's own behaviour untouched. */
(function(){
'use strict';

var MAP=null;
try{ MAP=JSON.parse(document.getElementById('yct-option-map').textContent); }catch(e){ return; }
if(!MAP||!MAP.options||!MAP.options.length) return;

var host=document.querySelector('[id^="shopify-section-"][id$="__main"]');
if(!host) return;
var SECTION=host.id.replace('shopify-section-','');

function sel(name){ return document.querySelector("select[name='options["+name+"]']"); }

function valueId(optName,valName){
  for(var i=0;i<MAP.options.length;i++){
    if(MAP.options[i].name!==optName) continue;
    var vs=MAP.options[i].values;
    for(var j=0;j<vs.length;j++){ if(vs[j].name===valName) return vs[j].id; }
  }
  return null;
}

var token=0, timer=null;

function apply(doc){
  var newId=doc.querySelector('form[action*="/cart/add"] [name="id"]');
  var curId=document.querySelector('form[action*="/cart/add"] [name="id"]');
  if(newId && curId && curId.value!==newId.value){
    curId.value=newId.value;
    try{ history.replaceState({},'', '?variant='+newId.value); }catch(e){}
  }
  var np=doc.querySelector('.price'), cp=document.querySelector('.price');
  if(np && cp && cp.innerHTML!==np.innerHTML) cp.innerHTML=np.innerHTML;

  var nb=doc.querySelector('form[action*="/cart/add"] [type="submit"]');
  var cb=document.querySelector('form[action*="/cart/add"] [type="submit"]');
  if(nb && cb){
    cb.disabled=nb.disabled;
    var nt=nb.querySelector('span'), ct=cb.querySelector('span');
    if(nt && ct) ct.textContent=nt.textContent;
    else if(!nt && !ct) cb.textContent=nb.textContent;
  }
}

function resolve(){
  var ids=[];
  for(var i=0;i<MAP.options.length;i++){
    var o=MAP.options[i];
    var s=sel(o.name);
    if(!s) return;
    var id=valueId(o.name, s.value);
    if(!id) return;
    ids.push(id);
  }
  var mine=++token;
  var url='/products/'+MAP.handle+'?section_id='+encodeURIComponent(SECTION)+
          '&option_values='+ids.join(',');
  fetch(url,{headers:{'Accept':'text/html'}})
    .then(function(r){ return r.ok ? r.text() : null; })
    .then(function(t){
      if(!t || mine!==token) return;
      apply(new DOMParser().parseFromString(t,'text/html'));
    })
    .catch(function(){});
}

function schedule(){
  if(timer) clearTimeout(timer);
  timer=setTimeout(resolve,140);
}

document.addEventListener('change',function(e){
  var t=e.target;
  if(t && t.name && t.name.indexOf('options[')===0) schedule();
},true);

schedule();
})();
